// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UsersModal_wrapper__1ze2e","header":"UsersModal_header__1Abrv","inputWrapper":"UsersModal_inputWrapper__2NbFr","button":"UsersModal_button__2WvNu"};